import styled from "styled-components";

export const SVG = styled.svg`
    display: block;
`;
